const PuertaIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 19H20C20.55 19 21 19.45 21 20C21 20.55 20.55 21 20 21H18C17.45 21 17 20.55 17 20V6H14V20C14 20.55 13.55 21 13 21H4C3.45 21 3 20.55 3 20C3 19.45 3.45 19 4 19H5V4C5 3.45 5.45 3 6 3H13C13.55 3 14 3.45 14 4H18C18.55 4 19 4.45 19 5V19ZM10 13H12V11H10V13Z"
        fill="white"
      />
    </svg>
  );
};

export default PuertaIcon;
